import React from 'react'
//import { Link } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import ServiceSidebar from '../components/ServiceSidebar'
import './ServiceCooperative.css'

function ServiceCooperative() {
    return (
        <>
            <PageHeader title="Online Co-operative Platform" />

            <div className="page-service-single">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <ServiceSidebar
                                activeService="/service-cooperative"
                                ctaTitle="Ready to Join Our Community?"
                                ctaLabel="Get started today"
                            />
                        </div>
                        <div className="col-lg-8">
                            <div className="service-single-content">
                                <div className="row align-items-center mb-5">
                                    <div className="col-md-7 coop-hero-content wow fadeInUp">
                                        <div className="coop-badge">
                                            <i className="fa-solid fa-circle-check"></i>{' '}
                                            BUILD A STRONG TRIBE
                                        </div>
                                        <h2>
                                            Join the{' '}
                                            <strong>Fidelanchor</strong>{' '}
                                            <span className="text-green">
                                                Cooperative Revolution!
                                            </span>
                                        </h2>
                                        <p>
                                            Easy Savings, Bulk Deals, Affordable
                                            Credit, Loans Without Wahala, Shared
                                            Profits, and a Community That Cares
                                            – Together We Win.
                                        </p>
                                        <div className="header-btn d-inline-flex">
                                    <a
                                        href="https://cooperative.fidelanchor.com"
                                        className="btn-default btn-highlighted"
                                    >
                                        Join Coop
                                    </a>
                                 </div>
                                    </div>
                                    <div
                                        className="col-md-5 coop-hero-image wow fadeInUp"
                                        data-wow-delay="0.2s"
                                    >
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/about-img-2.jpg`}
                                            alt="Cooperative Group"
                                        />
                                    </div>
                                </div>

                                <div
                                    className="coop-benefits-section wow fadeInUp"
                                    data-wow-delay="0.4s"
                                >
                                    <div className="section-title mb-4">
                                        <h3
                                            className="text-green"
                                            style={{
                                                fontSize: '0.9rem',
                                                letterSpacing: '1px',
                                                textTransform: 'uppercase',
                                                fontWeight: 700,
                                            }}
                                        >
                                            <i className="fa-solid fa-layer-group"></i>{' '}
                                            WHY JOIN?
                                        </h3>
                                        <h2
                                            style={{
                                                fontSize: '2rem',
                                                fontWeight: 700,
                                            }}
                                        >
                                            Unlock exclusive{' '}
                                            <span className="text-green">
                                                member benefits
                                            </span>
                                        </h2>
                                    </div>
                                    <div className="coop-benefits-grid">
                                        {[
                                            {
                                                icon: 'fa-hand-holding-dollar',
                                                title: 'Easy Low-Interest Loans',
                                            },
                                            {
                                                icon: 'fa-piggy-bank',
                                                title: 'Smart Savings & Dividends',
                                            },
                                            {
                                                icon: 'fa-cart-shopping',
                                                title: 'Bulk Buying Discounts',
                                            },
                                            {
                                                icon: 'fa-users-viewfinder',
                                                title: 'Pooled Investment',
                                            },
                                            {
                                                icon: 'fa-file-invoice-dollar',
                                                title: 'Tax Perks & Support',
                                            },
                                        ].map((benefit, idx) => (
                                            <div
                                                className="coop-card"
                                                key={idx}
                                            >
                                                <div className="card-top">
                                                    <div className="coop-icon-box">
                                                        <i
                                                            className={`fa-solid ${benefit.icon}`}
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div className="card-bottom">
                                                    <h3>{benefit.title}</h3>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceCooperative
